export default __webpack_public_path__ + "static/1-6c5d0a81f203d1aed2bc63f7967eb306.png";